// Como um anexo deve ser apresentado na mensagem, decidido só pelo mime.
//
// Mora fora do ChatMessage por ser lógica pura: o componente monta URL
// assinada, player e modal, e testar essa classificação por ele exigiria
// renderizar a árvore inteira.

export type TipoDeAnexo = 'imagem' | 'video' | 'audio' | 'arquivo';

export function tipoDoAnexo(fileType: string): TipoDeAnexo {
  const mime = (fileType || '').toLowerCase();

  // A ordem importa: `audio/mp4` (o que o Safari grava) não pode cair no ramo
  // de vídeo, ou o áudio abriria num player mostrando uma tela preta.
  if (mime.startsWith('image/')) return 'imagem';
  if (mime.startsWith('audio/')) return 'audio';
  if (mime.startsWith('video/')) return 'video';
  return 'arquivo';
}
